<template>
<!--  <div class="fct-form-group">-->
    <label>{{displayName || fieldName | unsnake | capitalize}} ({{condition | capitalize}}):
      <input class="fct-input"
             type="number"
             @change="doFilter" v-model.number="inputVal">
    </label>
<!--  </div>-->
</template>

<script>
import chainableVModel from "../../mixins/chainableVModel";
import {get} from 'lodash'

let predicateFactoryByCondition = {
  min: (num, field, transform) => (obj) => num <= transform(get(obj, field)),
  max: (num, field, transform) => (obj) => transform(get(obj, field)) <= num
}

let queryFactoryByCondition = {
  min: (num, field) => ({[field]: {$gte: num}}),
  max: (num, field) => ({[field]: {$lte: num}})
}

export default {
  props: {
    condition: {
      type: String
    },
    filterManager: Object,
    fieldName: String,
    displayName: String,
    transform: {
      type: Function,
      default: a => a
    }
  },
  mixins: [chainableVModel],
  methods: {
    doFilter() {
      this.filterManager.setFilter(this.fieldName + '-' + this.condition,
        predicateFactoryByCondition[this.condition](this.value, this.fieldName, this.transform),
        queryFactoryByCondition[this.condition](this.value, this.fieldName, this.transform))
    },
  },
  mounted () {
    this.doFilter()
  }
}
</script>

<style scoped lang="scss">
</style>
